import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  AfterViewInit,
  ViewEncapsulation,
  AfterViewChecked,
} from '@angular/core';
import {
  Event,
  NavigationStart,
  Router,
  ActivatedRoute,
} from '@angular/router';
import { Location } from '@angular/common';
import { CommonServiceService } from './common-service.service';
import {BaseService} from './base.service'
import { I } from '@angular/cdk/keycodes';
// import { RobinCustomerService } from './robin-customer.service'
// import {BaseService} from './shard/RobinCustomer.service'








@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  //changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit, AfterViewChecked {
  title = 'doccure';
  url;
  loadFooter = false;
  show: boolean = true;
  hideFooter: boolean = false;
  constructor(
    public router: Router,
    private activeRoute: ActivatedRoute,
   private BaseService :BaseService,
    private changeDetector: ChangeDetectorRef,
  
    public Router: Router,
    location: Location,
    public commonServic: CommonServiceService
  ) {
    // document.querySelector("body").style.cssText = "--footer-var: linear-gradient(to right,#fc0, #ffe57f)";
    
  // console.log(this.robinCustomerService. print());

    Router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        if (
          event.url == '/login' ||
          event.url == '/forgot-password' ||
          event.url == '/Register'
        ) {
          document.querySelector('body').classList.add('account-page');
          document.querySelector('body').classList.remove('mat-typography');
          if (event.url == '/login') {
            this.Router.navigateByUrl('/login');
          }
        } else {
          document.querySelector('body').classList.remove('account-page');
          document.querySelector('body').classList.add('mat-typography');
        }
        if (event.url == '/map-grid') {
          this.hideFooter = true;
        }
        if (event.url == '/video-call' || event.url == '/voice-call') {
          document.querySelector('body').classList.add('call-page');
          document.querySelector('body').classList.remove('mat-typography');
        } else {
          document.querySelector('body').classList.remove('call-page');
          document.querySelector('body').classList.add('mat-typography');
        }
      }
    });
    this.url = location.path();
    this.show = this.url.includes('admin') ? false : true;
    this.show = this.url.includes('pharmacy-admin') ? false : true;
    this.show = this.url.includes('dashboard') ? false : true;
    this.commonServic.message.subscribe((res) => {
      if (res === 'admin' || res === 'pharmacy-admin' || res === 'dashboard') {
        this.show = false;
        this.hideFooter = true;
      } else if (res === 'main') {
        this.show = true;
        this.hideFooter = false;
      } else if (res === 'chat') {
        this.show = true;
        this.hideFooter = true;
      } else {
        this.show = true;
        this.hideFooter = false;
      }
    });
  }
  
  // getProvider() {
  //   // '/api/doctors/ShowProfile/11'
  //   this.baseService.post('get_provider/1', {})
  //   .then(
  //     (val: any) => {
  //        console.log('get_provider',val);
  //     },
  //     (err) => {
  //       console.log(err);

  //        console.log('afsfsfs');
  //     }
  //   );
  // }
  /******** NEW DATA FAYAD  *********/
  Provider;
  MianColoe={
    color1 : null,
    textColor1: null,
    color2 : null,
    textColor2 : null,
    color3: null ,
    textColor3 : null
  }
  loading = false
  /******** NEW DATA FAYAD  *********/
  ngOnInit() {
    if( localStorage.getItem('get_provider')){
      console.log('OK get_provider')
      var id = JSON.parse(localStorage.getItem('get_provider')).id ; 
      // this.getProvider(id);
    }
    // var id = this.activeRoute.snapshot.paramMap.get('id');
    // console.log('prviderId == ' , id);
    // this.getProvider(id);
    setTimeout(() => (this.loadFooter = true), 2000);
  this.BaseService.subject_Change.subscribe((value : boolean) => {
    this.loading  = value
    console.log('loadingggggggggggggggggggggg' , this.loading)
  })
  }

  ngAfterViewChecked() {
    this.changeDetector.detectChanges();
  }
  getProvider(id) {
    this.BaseService.post('get_provider/'+id, {}).then(
      (val: any) => {
        // localStorage.clear()
        localStorage.setItem('get_provider', JSON.stringify(val) );
        console.log(val);
        this.Provider = val;
        this.MianColoe.color1 = this.Provider.color1;
        this.MianColoe.color2 =  this.Provider.color2;
        this.MianColoe.color3 =  this.Provider.color3;
        this.PlaceColor();
        localStorage.setItem('MianColoe', JSON.stringify(this.MianColoe));
        console.log(this.MianColoe)
        if(this.Provider.font != null){
          var font =this.Provider.font.name
        }
        // var color = '#fc0'
        var footerColor = '--footer-var';
        var footreText = '--footer_text-var';
        var headeColor = '--header-var';
        var headeColorActiveHover = '--header_active-var'
        var headerText = '--header_text-var';
        var headerActiveHoverText = '--header_text_active-var';
        var footerActiveHoverText = '--footer_text_active-var'
       document.querySelector("html").style.cssText =    headerText+':'+' '+ this.MianColoe.textColor1 +';'
                                                       + headeColor+':'+' '+   this.MianColoe.color1 +';'
                                                       + headeColorActiveHover+':'+' '+   this.MianColoe.color1 +'e0'+';' 
                                                       + footerColor+':'+' '+ this.MianColoe.color2 +';'
                                                       + footreText+':'+' '+ this.MianColoe.textColor2 +';'
                                                       + headerActiveHoverText +':'+' '+ this.MianColoe.textColor1 +'c9'+';'
                                                       + footerActiveHoverText +':'+' '+ this.MianColoe.textColor1 +'c9';

                                                      //  this.router.navigate(['/plcing-order']);
        // document.querySelector("body").style.cssText = "--footer-var:  linear-gradient(to right,#fc0, #ffe57f) ; --header-var:  linear-gradient(to right,#fc0, #ffe57f) ";
      },
      (err) => {
        console.log(err);
      }
    );
  }

  PlaceColor(){
    if (this.MianColoe.color1) {
      if (this.MianColoe.color1.substring(1) > "7fffff") {
        this.MianColoe.textColor1 = "#333";
      }
      else {
        this.MianColoe.textColor1 = "#ffffff";
      }
    }
    if (this.MianColoe.color2) {
      if (this.MianColoe.color2.substring(1) > "7fffff") {
        this.MianColoe.textColor2 = "#333";
      }
      else {
        this.MianColoe.textColor2 = "#ffffff";
      }
    }
    if (this.MianColoe.color3) {
      if (this.MianColoe.color3.substring(1) > "7fffff") {
        this.MianColoe.textColor3 = "#333";
      }
      else {
        this.MianColoe.textColor3 = "#ffffff";
      }
    }
  }
  pickTextColorBasedOnBgColorAdvanced(bgColor, lightColor, darkColor,) {
    // var color = (bgColor.charAt(0) === '#') ? bgColor.substring(1, 7) : bgColor;
    // var r = parseInt(color.substring(0, 2), 16); 
    // // hexToR
    // var  g = parseInt(color.substring(2, 4), 16); 
    // // hexToG
    // var b = parseInt(color.substring(4, 6), 16); 
    // // hexToB
    // var uicolors = [r / 255, g / 255, b / 255]; 
    // var c = uicolors.map((col) => { if (col <= 0.03928) { return col / 12.92; }
    // return Math.pow((col + 0.055) / 1.055, 2.4); });
    // var L = (0.2126 * c[0]) + (0.7152 * c[1]) + (0.0722 * c[2]);
    // return (L > 0.179) ? darkColor : lightColor; 

}
}
